import React, {useEffect, useState} from "react";
import {MetricsSummary} from "./MetricsSummary";
import {faClipboardCheck, faPhone, faSuitcaseMedical} from "@fortawesome/free-solid-svg-icons";
import {GroupButtons} from "../../../organizationManagement/components/GroupButtons";
import {getGroupPathByName} from "../../model/dashboardHelpers";
import {calculateTimeElapsed} from "../../model/dashboardAnalytics";
import {Typography} from "../../../../designSystem/components/Typography";
import {DashboardCard} from "../../../../designSystem/components/DashboardCard";

export const TimeElapsedSummary = ({cases, selectedGroup, onChangeSelectedGroup}) => {
  const [averageAcceptedDays, setAverageAcceptedDays] = useState(0);
  const [averageContactDays, setAverageContactDays] = useState(0);
  const [averageServiceDays, setAverageServiceDays] = useState(0);
  const groupPath = getGroupPathByName(selectedGroup)

  useEffect(() => {
    const filteredCases = cases
      .filter(c => {
        if (groupPath === '') return true;
        return (c.category === groupPath)
      })

    const {tempAverageAcceptedDays, tempAverageContactDays, tempAverageServiceDays} = calculateTimeElapsed(filteredCases)
    setAverageAcceptedDays(tempAverageAcceptedDays)
    setAverageContactDays(tempAverageContactDays)
    setAverageServiceDays(tempAverageServiceDays)
  }, [cases, selectedGroup])

  return (
    <DashboardCard>
      <Typography variant="subtitle">
        服務天數平均統計
      </Typography>
      <GroupButtons
        selectedGroup={selectedGroup}
        onChangeSelectedGroup={onChangeSelectedGroup}
      />
      <div className={"flex flex-row gap-x-4 justify-between"}>
        <MetricsSummary
          title={"案件收案平均天數"}
          icon={faClipboardCheck}
          value={`${averageAcceptedDays.toFixed(2)}天`}
          iconColor={"text-blue-500"}
        />
        <MetricsSummary
          title={"案件聯繫平均天數"}
          icon={faPhone}
          value={`${averageContactDays.toFixed(2)}天`}
          iconColor={"text-blue-500"}
        />
        <MetricsSummary
          title={"案件服務平均天數"}
          icon={faSuitcaseMedical}
          value={`${averageServiceDays.toFixed(2)}天`}
          iconColor={"text-blue-500"}
        />
      </div>
    </DashboardCard>
  )
}
